<script>
	import { Doughnut } from 'vue-chartjs';

	export default {
		extends: Doughnut,
		props: ['data'],

		generateColor() {
			const letters = '0123456789ABCDEF';
			let color = '#';

			for (let i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}

			return color;
		},

		mounted() {
			this.renderChart(
				{
					labels: this.data.map((item) => item.regiao || 'Sem nome'),

					datasets: [
						{
							data: this.data.map((item) => item.qnt),
							backgroundColor: this.data.map(
								() =>
									'#' +
									Math.floor(Math.random() * 0x1000000)
										.toString(16)
										.padStart(6, '0')
							),
						},
					],
				},
				{
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						position: 'right',
					},
				}
			);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/exames_dashboard/components/contratos-por-regiao.vue